
import { render } from '@wordpress/element';
import { MapBoxMap } from './components/MapBoxMap'

window.addEventListener('DOMContentLoaded', (event) => {
    const wrappers = document.getElementsByClassName(`location-map-wrapper`);
    let accessToken = 'pk.eyJ1IjoieXJlaWpuZXJzc2lsZW50ZGlzY29kaXJlY3QiLCJhIjoiY20yNHV6NDE0MGs2djJtc2pkOGMwZzM5ZiJ9.xkLG3vokA6PECFd1gU2Uog'

    for(let wrapper of wrappers) {
        
        render(<MapBoxMap accessToken={accessToken}/>, wrapper);
    }
});